export const formatCurreny = (currency) => {
    const currencyValue = currency != null ? currency : 0;
    const currencyStr = currencyValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return `Rs. ${currencyStr}`;
}